export enum Type {
  /** Someone needs to look at the repair or part. */
  INSPECTION = 'INSPECTION',

  /** Documents are missing, like receipts or maintenance records. */
  RECORDS = 'RECORDS',
}
